import { validateNumber, validateString } from 'avilatek-utils';
import { Currency } from '../../models';

export function validateCurrencyForm({
  name,
  symbol,
  rate,
}: Partial<Currency>): string {
  if (!validateString(name) || String(name).length > 127) {
    return 'Nombre inválido';
  }

  if (!validateString(symbol) || String(name).length > 127) {
    return 'Simbolo inválido';
  }

  if (!validateNumber(rate) || Number(rate) < 0) {
    return 'Tasa inválido';
  }

  return '';
}
